import angular from 'angular';

import LogoModule from 'common/component/logo';
import FooterComponent from './footer.cmpt';

export default angular
    .module('presentation.component.footer', [
        LogoModule.name
    ])
    .component(FooterComponent.selector, FooterComponent);



// WEBPACK FOOTER //
// ./src/presentation/component/footer/index.js